export enum TYPE_REPORT {
	COLISEUM_CALL_REQUESTS = 'сoliseum_call_requests',
	COLISEUM_BLOCKS = 'call_easy/reports/blocks',
	COLISEUM_BLACK_LISTS = 'call_easy/reports/black_lists',
	COLISEUM_STATISTICS = 'call_easy/reports/call_request_statistics',
	RBIDOS_REQUEST_STATISTICS = 'reports/rbidos_request_statistics',
	RBIDOS_REQUEST = 'reports/rbidos_requests',
	CLICK_THROUGH = '/reports/click_through',
	STATISTICS_NEO = 'reports/neo_statistics',
	SMS = 'reports/sms',
	EVENTS_REPORTS = 'reports',
	EVENTS_USERS = 'events_users',
	EVENTS_ORDERS = 'events_orders',
	EVENTS_NEW_ORDERS = 'events_new_orders',
	EVENTS_PARTNERS = 'events_partners',
	EVENTS_RBIDOS_REQUESTS = 'events_rbidos_requests',
	EVENTS_CUSTOMER_IDENTIFICATIONS = 'events_customer_identifications',
	EVENTS_UNBLOCK_REQUESTS = 'events_unblock_requests',
	EVENTS_PRODUCTS = 'events_products',
	STATISTICS = 'statistics',
	NEPAL_ACTS = 'nepal_acts',
	BG_REPORTS = 'bg_reports',
	BG_REPORTS_EXTENDED = 'bg_reports_extended',
	SBER_CONFIRMATION = 'sber_confirmation',
	BG_REQUEST_STATISTICS = 'request_statistics',
	PARTNER_REQUEST = 'partner_requests',
	SDEX_LOGS = 'reports/sber_big_data_logs',
	PARTNER_CONTRACTS = 'partner_contracts',
	PARTNERS_REGISTRY = 'partners_registry',
	DEPARTMENTS = 'reports/departments',
	ORDER_TASKS_LOGS = 'reports/task_model',
	CREATIVE_PAYMENTS = 'creative_payments',
	BULK_CREATION = 'bulk_creation',
	USERS_API = 'reports/users_api',
	SELF_EMPLOYED_LOGS = 'sber_mq/reports/self_employed_logs',
	SBER_DEPARTMENTS = 'reports/sber_departments',
	CALL_EASY_NEW_REGISTRATION = 'reports/call_easy_new_registration',
	SEARCH_CLIENT = 'reports/search_client',
	PARTNER_ANTIFRAUD = 'reports/partner_antifrauds',
	BLACK_LIST_PARTNERS = 'reports/black_list_partners',
	INFOTECS_REQUESTS = 'infotecs_requests',
	EVENTS_DEPARTMENTS = 'events_departments',
	EVENTS_CUSTOMER_IDENTIFICATIONS_DOCUMENT_PREDICTIONS = 'events_customer_identifications_document_predictions',
	BG_CALCULATE_COMMISSION = 'bg_calculate_commission',
	ADS = 'ads',
	ADS_CREATIVES = 'ads_creatives',
	ADS_INVOICES = 'ads_invoices',
	CSAT_METRICS = 'csat_metrics',
	OPEN_SOURCE_REQUESTS = 'open_source_requests',
	UNBLOCK_REQUESTS = 'reports/unblock_requests',
	BLANK_REGISTRATION_DATE_ORDERS = 'sber_mq/reports/events_order_blank_registration_date',
	SVETOFOR_REQUESTS = 'svetofor_requests',
	PARTNER_BIRTHDAYS = 'reports/partner_birthdays',
	USERS = 'users',
}
